import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import './CompanyRegister.css';

function CompanyRegister() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    code: '',
    ceo: '',
    businessNumber: '',
    address: '',
    phone: '',
    employees: '',
    status: '활성'
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = '회사명을 입력해주세요';
    }
    if (!formData.code.trim()) {
      newErrors.code = '회사코드를 입력해주세요';
    }
    if (!formData.ceo.trim()) {
      newErrors.ceo = '대표이사를 입력해주세요';
    }
    if (!formData.businessNumber.trim()) {
      newErrors.businessNumber = '사업자번호를 입력해주세요';
    } else if (!/^\d{3}-\d{2}-\d{5}$/.test(formData.businessNumber)) {
      newErrors.businessNumber = '사업자번호 형식이 올바르지 않습니다 (예: 123-81-00998)';
    }
    if (!formData.address.trim()) {
      newErrors.address = '주소를 입력해주세요';
    }
    if (!formData.phone.trim()) {
      newErrors.phone = '연락처를 입력해주세요';
    } else if (!/^\d{2,3}-\d{3,4}-\d{4}$/.test(formData.phone)) {
      newErrors.phone = '연락처 형식이 올바르지 않습니다 (예: 031-200-1114)';
    }
    if (!formData.employees) {
      newErrors.employees = '직원수를 입력해주세요';
    } else if (isNaN(formData.employees) || formData.employees < 1) {
      newErrors.employees = '유효한 직원수를 입력해주세요';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    // TODO: API 호출로 회사 등록
    

    // 등록 후 관리자 페이지로 이동
    navigate('/admin');
  };

  const handleCancel = () => {
    navigate('/admin');
  };

  return (
    <MainLayout>
      <div className="company-register-container">
        <div className="company-register-header">
          <div className="company-register-header-left">
            <div className="back-btn" onClick={handleCancel}>
              <span class="material-symbols-outlined">
                arrow_back_ios
              </span>
            </div>
            <div>
              <div className="company-register-title">회사 등록</div>
              <p className="company-register-subtitle">새로운 회사 정보를 등록합니다</p>
            </div>
          </div>
        </div>

        <form className="company-register-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h3 className="section-title">기본 정보</h3>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">
                  회사명 <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  className={`form-input ${errors.name ? 'error' : ''}`}
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="회사명을 입력하세요"
                />
                {errors.name && <span className="error-message">{errors.name}</span>}
              </div>

              <div className="form-group">
                <label className="form-label">
                  회사코드 <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="code"
                  className={`form-input ${errors.code ? 'error' : ''}`}
                  value={formData.code}
                  onChange={handleChange}
                  placeholder="회사코드를 입력하세요"
                />
                {errors.code && <span className="error-message">{errors.code}</span>}
              </div>

              <div className="form-group">
                <label className="form-label">
                  대표이사 <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="ceo"
                  className={`form-input ${errors.ceo ? 'error' : ''}`}
                  value={formData.ceo}
                  onChange={handleChange}
                  placeholder="대표이사명을 입력하세요"
                />
                {errors.ceo && <span className="error-message">{errors.ceo}</span>}
              </div>

              <div className="form-group">
                <label className="form-label">
                  사업자번호 <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="businessNumber"
                  className={`form-input ${errors.businessNumber ? 'error' : ''}`}
                  value={formData.businessNumber}
                  onChange={handleChange}
                  placeholder="123-81-00998"
                />
                {errors.businessNumber && <span className="error-message">{errors.businessNumber}</span>}
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="section-title">연락 정보</h3>
            <div className="form-grid">
              <div className="form-group form-group-full">
                <label className="form-label">
                  주소 <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="address"
                  className={`form-input ${errors.address ? 'error' : ''}`}
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="주소를 입력하세요"
                />
                {errors.address && <span className="error-message">{errors.address}</span>}
              </div>

              <div className="form-group">
                <label className="form-label">
                  연락처 <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="phone"
                  className={`form-input ${errors.phone ? 'error' : ''}`}
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="031-200-1114"
                />
                {errors.phone && <span className="error-message">{errors.phone}</span>}
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="section-title">운영 정보</h3>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">
                  직원수 <span className="required">*</span>
                </label>
                <input
                  type="number"
                  name="employees"
                  className={`form-input ${errors.employees ? 'error' : ''}`}
                  value={formData.employees}
                  onChange={handleChange}
                  placeholder="직원수를 입력하세요"
                  min="1"
                />
                {errors.employees && <span className="error-message">{errors.employees}</span>}
              </div>

              <div className="form-group">
                <label className="form-label">
                  상태 <span className="required">*</span>
                </label>
                <div className="dropdown-container">
                  <select
                    name="status"
                    className="form-select"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="활성">활성</option>
                    <option value="비활성">비활성</option>
                  </select>
                  <svg className="dropdown-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={handleCancel}>
              취소
            </button>
            <button type="submit" className="btn-submit">
              등록
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
}

export default CompanyRegister;
